import {Pipe, PipeTransform} from '@angular/core';
import {Project, typeToUrl} from "../api/model/project";
import {ProjectInfo} from "../api/model/alert";

@Pipe({
  name: 'url'
})
export class UrlPipe implements PipeTransform {
  transform(project: ProjectInfo | Project | undefined): string {
    return project ? projectUrl(project,) : "";
  }
}

export function projectUrl(project: ProjectInfo | Project): string {
  const firstPart = typeToUrl(project.type);
  return `/${firstPart}/${project.accountingId}/${project.id}`;
}
